import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { ExpertId } from '@packages/shared/core/experts/entities';
import {
  chatSessionUpdated,
  getHasChatSessionEverBeen,
  getIncomingMessage,
  getOutgoingMessage,
  messageReceived,
  messageReceivedRequest,
  messageSent,
} from '../store';

export function useChat(expertId: ExpertId) {
  const dispatch = useDispatch();

  const incomingMessage = useSelector(getIncomingMessage(expertId));
  const outgoingMessage = useSelector(getOutgoingMessage(expertId));
  const hasChatSessionEverBeen = useSelector(getHasChatSessionEverBeen(expertId));

  const sendMessage = useCallback(
    (text: string) => {
      dispatch(messageSent({ expertId, text }));
    },
    [dispatch, expertId],
  );

  const receiveMessageRequest = useCallback(() => {
    dispatch(messageReceivedRequest(expertId));
  }, [dispatch, expertId]);

  const receiveMessage = useCallback((text: string) => {
    dispatch(messageReceived({ expertId, text }));
  }, [dispatch, expertId]);

  const updateChatSession = useCallback(() => {
    dispatch(chatSessionUpdated(expertId));
  }, [dispatch, expertId]);

  return {
    incomingMessage,
    outgoingMessage,
    sendMessage,
    receiveMessage,
    receiveMessageRequest,
    updateChatSession,
    hasChatSessionEverBeen,
  };
}
